import React, {useState, useEffect, lazy, Suspense } from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import { graphql, Link } from 'gatsby'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import Pinterest from '../images/pinterest2.svg'
import { Helmet } from "react-helmet"
// takes JSON of body from API and returns react components
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import {firestore} from '../../firebase'
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { OutboundLink } from "gatsby-plugin-google-gtag"
import humanizeDuration from 'humanize-duration'; 

import Layout from '../components/layout'
import Seo from '../components/seo'
import * as blogPageStyles from './blogPage.module.scss'

const RecipeCard = lazy(() => import ('../components/RecipeCard'))
const Comments = lazy(() => import('../components/Comments'))
const SocialBlock = lazy(() => import('../components/socialBlock'))
const SocialShareFull = lazy(() => import('../components/SocialShareFull'))
const VideoFrame = lazy(() => import("../components/VideoFrame"));
// const SaveRecipeForm = lazy(() => import('../components/saveRecipeForm'))

// Add back to graphql schema under RoundupRecipeGroups -> Recipe


export const query = graphql`
  query ($slug: String, $blogId: String) {
    allComments (filter: {blogId: {eq: $blogId}}){
      edges {
        node {
          rating
        }
      }
    }

    allContentfulSidebarRecipes {
      edges {
        node {
          contentful_id
          groupName
          display
          recipe {
            blogTitle
            slug
            category {
              slug
            }
            thumbnailImage {
              imgixImage {
                gatsbyImageData (width: 600, imgixParams: {q: 75, crop: "entropy", mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
              }
              title
            }
          }
        }
      }
    }
    contentfulBlogPost (slug: {eq: $slug}) {
          contentful_id
          isRoundup
          roundupRecipeGroups {
              title
              description {
                description
              }
              recipe {
                url
                image {
                  title
                  imgixImage {
                    gatsbyImageData (width: 2000, layout: FULL_WIDTH, imgixParams: {q: 75, crop: "entropy"})
                  }
                }
                easy
                prepTime
                cookTime
                totalTime
                  name
                  description {
                    raw
                  }
                  recipe {
                    category {
                      slug
                    }
                    slug
                    thumbnailImage {
                      imgixImage {
                        gatsbyImageData (width: 2000, layout: FULL_WIDTH, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
                      }
                      title
                    
                    }
                    easy
                    prepTime
                    cookTime
                    totalTime
                  }
                
              }
            
          }
          metaDescription
          blogTitle
          subtitle
          publishedDate 
          modifiedDate
          enableComments
          showToc
          showTocH2Only
          slug
          category {
            name
            slug
          }
          thumbnailImage {
            file {
              url 
            }
            imgixImage {
              gatsbyImageData (width: 2000, layout: FULL_WIDTH, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
              url 
            }
            title
          }
          pinterestImage {
            imgixImage {
              gatsbyImageData (width: 800, imgixParams: {q: 75, crop: "entropy"})
              url
            }
          }
          bottomImage {
            imgixImage {
              gatsbyImageData (width: 2000, layout: FULL_WIDTH, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
            }
            title
          }
          subcategory {
            name
            
          }
          tags {
            name
            slug
          }
          sellPara {
            raw
            references {
              ...on ContentfulAsset {

                contentful_id
                __typename
                imgixImage {
                  gatsbyImageData (width: 2000, layout: FULL_WIDTH, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png", markScale: 10})
                }
                title
                description
                file {
                  contentType
                }
              }
            }
          }
          body {
            raw
            references {
              ... on ContentfulBlogPost {
                contentful_id
                __typename
                category {
                  slug
                }
                slug
              }
             
              ...on ContentfulAsset {

                contentful_id
                __typename
                imgixImage {
                  gatsbyImageData (width: 2000, layout: FULL_WIDTH, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png", markScale: 10})
                }
                title
                description
                file {
                  url
                  contentType
                }
              }
            
            }
          }
          author {
            authorName
            authorBio {
              raw
            }
            authorProfilePicture {
              imgixImage {
                gatsbyImageData (width: 800, imgixParams: {q: 75})
              }
              description
            }
          }
          youtubeLink
          youtubeVideo {
            title
            embedUrl
            contentUrl
            uploadDate
            thumbnail {
              imgixImage {
                url
              }
            }
            description {
              description
            }
          }
          cookTime
          prepTime
          totalTime
          servings
          recipeYield
          recipeCategory
          recipeCuisine
          easy
          meal {
            blog_post {
              blogTitle
            }
            name
            slug
          }
          mealType {
            blog_post {
              blogTitle
            }
            name
            slug
          }
          occasion {
            blog_post {
              blogTitle
            }
            name
            slug
          }
          mainIngredient {
            blog_post {
              blogTitle
            }
            name
            slug
          }
          cuisine {
            blog_post {
              blogTitle
            }
            name
            slug
          }
          keywords
          defaultMeasurements
          recipeIngredientGroup {
            contentful_id
            groupName 
            ingredients {
              contentful_id
              ingredientSchemaName
              usMeasurement
              usUnit
              addlUsMeasurement
              addlUsUnit
              metricMeasurement
              metricUnit
              preparationModifiers
              replacementIngredientName
              nutritionMultiplier
              ingredient {
                ingredientName
                affiliateLink
                externalLink
                internalLink {
                  category {
                    slug
                  }
                  slug
                }
                calories
                fat
                saturatedFat
                cholesterol
                sodium
                carbohydrates
                fiber
                sugar
                protein
                vitaminA
                vitaminB12
                vitaminC
                vitaminD
                calcium
                iron
                potassium
                zinc
              }
            }
          }
          recipeInstructions {
            contentful_id
            name
            text {
              childMarkdownRemark {
                html
              }
            }
            image {
              imgixImage {
                gatsbyImageData (width: 2000, layout: FULL_WIDTH, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
                url
              }
              title
              description
            }
          }
          recipeNotes 
          relatedPosts {
            blogTitle
            category {
              slug
            }
            slug
            thumbnailImage {
              imgixImage {
                gatsbyImageData (width: 800, imgixParams: {q: 75, crop: "entropy", mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
              }
              title
            }
          }
          amazonProductCode {
            amazonProductCode
          }
          containsAffiliateLinks
    }
  }
`

const Blog = (props) => {
  

  const config = {
    thresholds: [
      { l: 's', r: 1 },
      {1: 'ss', r: 59},
  { l: 'm', r: 1 },
  { l: 'mm', r: 119, d: 'minute' },
  { l: 'h', r: 1 },
  { l: 'hh', r: 23, d: 'hour' },
  { l: 'd', r: 1 },
  { l: 'dd', r: 29, d: 'day' },
  { l: 'M', r: 1 },
  { l: 'MM', r: 11, d: 'month' },
  { l: 'y' },
  { l: 'yy', d: 'year' }
  ]
  }
  
  dayjs.extend(relativeTime, config)
  dayjs.extend(duration)
  dayjs.extend(updateLocale)

dayjs.updateLocale('en', {
   
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: 'n/a',
        m: "n/a",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      
      }, 
}) // Your Day.js locale Object.

const metaType = 'article'
const post = props.data.contentfulBlogPost

let isRecipe
post.subcategory[0].name === 'Recipes' ? isRecipe = true : isRecipe = false

 let isRoundup
 props.data.contentfulBlogPost.isRoundup === true ? isRoundup = true : isRoundup = false

  const tocOptions={
    renderNode: {
      [BLOCKS.HEADING_2]: ({ content }) => (<Link to={`#${content[0].value}`}><li className={blogPageStyles.tocH2}>{content[0].value}</li></Link>),
      [BLOCKS.HEADING_3]: ({ content }) => (<Link to={`#${content[0].value}`}><li className={blogPageStyles.tocH3}>{content[0].value}</li></Link>)
    }
  }
  const headingTypes = [BLOCKS.HEADING_2, BLOCKS.HEADING_3]
  const headingH2 = [BLOCKS.HEADING_2]
  
  const headings = JSON.parse(props.data.contentfulBlogPost.body.raw).content.filter(item => headingTypes.includes(item.nodeType))
  let headingsH2 = []
  isRoundup === false ?
    headingsH2 = JSON.parse(props.data.contentfulBlogPost.body.raw).content.filter(item => headingH2.includes(item.nodeType))
    :
    props.data.contentfulBlogPost.roundupRecipeGroups.map(group => {
      headingsH2.push({
        nodeType: "heading-2",
        data: {
          nodeType: "heading-2"
        },
        content: [{
          nodeType: "text",
          value: `${group.title}`,
          marks: [],
          data: {}
        }]
      }) 
      return headingsH2
    })
  

console.log(headingsH2)
  const tocDocument = {
    nodeType: 'document',
    content: headings,
  }

  const tocH2Document = {
    nodeType: 'document',
    content: headingsH2,
  }

  const options = {
    renderNode: {
      
      [INLINES.ENTRY_HYPERLINK]: ({
        data: {
          target: {slug, category},
        },
        content
        
      }) => <Link to={`/${category[0].slug}/${slug}`}>{content[0].value}</Link>,
      [INLINES.HYPERLINK]: ({
        data,
        content
      }) => (<OutboundLink target="__blank" rel="nofollow" href={data.uri}>{content[0].value}</OutboundLink>),
      [BLOCKS.EMBEDDED_ENTRY]: ({
          data
      })=> (<div className={blogPageStyles.amazonImage}><div className={blogPageStyles.amazonBlock} dangerouslySetInnerHTML={{__html: data.target.amazonCode.amazonCode}}></div></div>),
      [BLOCKS.HEADING_2]: ({ content }) => (<h2 className="bodyH2" id={content[0].value}>{content[0].value}</h2>),
      [BLOCKS.HEADING_3]: ({ content }) => (<h3 className="bodyH3" id={content[0].value}>{content[0].value}</h3>),
      [BLOCKS.EMBEDDED_ASSET]: ({
        data: {
          target: {imgixImage, title, description, file}
        }
      }) => (file.contentType === "image/gif" ? <div className={blogPageStyles.imageBlock}>
        <img className={blogPageStyles.gif} src={file.url} alt={title} />
        <div className={blogPageStyles.imageCaption}>{description}</div> 
      </div> : 
      <div className={blogPageStyles.imageBlock}>
        <GatsbyImage image={imgixImage.gatsbyImageData} alt={title}/>
      <div className={blogPageStyles.imageCaption}>{description}</div> 
      </div>)

      
      
    }
  }

  



  const mealType = post.mealType || []
  const meal = post.meal || []
  const occasion = post.occasion || []
  const cuisine = post.cuisine || []
  const mainIngredient = post.mainIngredient || []
  const totalTime = post.totalTime || 0

  const [comments, setComments] = useState([{name: "", email: "", content: "", key: "", rating: null, pId: null, time: null}])
  // const [aggregateRating, setAggregateRating] = useState(null)
  // const [ratingQuantity, setRatingQuantity] = useState(null)
  const blogId = post.contentful_id
  const blogPath = `${post.category[0].slug}/${post.slug}`

  let ratingQuantity

  const setRating = (edge) => {
    let ratingArray = []
    edge.map((edge) => {
      if (!!edge.node.rating === true) {
        ratingArray.push(edge.node.rating)
      } 
      return ratingArray
    })
    ratingQuantity = ratingArray.length
    return ratingArray.reduce((a, b) => a + b, 0) / ratingArray.length
  }

  const aggregateRating = setRating(props.data.allComments.edges)


  // async function setRating() {
  //   let ratingArray = []
  //   props.data.allComments.edges.map((edge) => {
  //     if (!!edge.node.rating === true) {
  //       ratingArray.push(edge.node.rating)
  //     } 
  //     return ratingArray
  //   })
  //   const ratingAvg = await ratingArray.reduce((a, b) => a + b, 0) / ratingArray.length
  //   setAggregateRating(ratingAvg)
  //   setRatingQuantity(ratingArray.length)

  // }  

  // setRating()
 


      // nutrition data calculations

      const servings = props.data.contentfulBlogPost.servings
      const groups = props.data.contentfulBlogPost.recipeIngredientGroup

      let ingredients = []
        const group = props.data.contentfulBlogPost.recipeIngredientGroup || []
        group.map((group) => {
          group.ingredients.map((ingredient) => {
            ingredients.push(ingredient.ingredient.ingredientName)
            return ingredients
          })
          return ingredients
        })
        const ingLength = ingredients.length

        // Dietary info to work on later. Not sure if this works. 
        // Need to add back in allergensAndDiets to GraphQL Schema
      //   let isGlutenFree = true
      //   let isNutFree = true
      //   let isHalal = true
      //   let isSoyFree = true
        
      // const dietCalc = (groups) => {
      //   groups.map((group) => {
      //     group.ingredients.map((ingredient) => {
      //       ingredient.allergensAndDiets.map((diet) => {
      //         if (diet === "Contains gluten") then (isGlutenFree = false);
      //         if (diet === "Contains tree nuts") then (isNutFree = false);
      //         if (diet === "Contains soy") then (isSoyFree = false);
      //         if (diet === "Contains non-Halal (alcohol)") then (isHalal = false);
      //       })
           
      //     })
      //   })
      // }

      const caloriesCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.calories * ingredient.nutritionMultiplier)
          return x
        })
        return x
      }) 
      
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const fatCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.fat * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const satFatCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.saturatedFat * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }

    
      const cholestCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.cholesterol * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }

    
      const sodiumCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.sodium * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }

    
      const carbsCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.carbohydrates * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }

      const fiberCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.fiber * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
 
    
      const sugarCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.sugar * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const proteinCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.protein * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const vitACalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.vitaminA * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const vitB12Calc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.vitaminB12 * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const vitCCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.vitaminC * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const vitDCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.vitaminD * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const calcCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.calcium * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const ironCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.iron * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const potasCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.potassium * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }
    
      const zincCalc = (groups) => {
        let x = []
        groups.map((group) => {
        group.ingredients.map((ingredient) =>{
          x.push(ingredient.ingredient.zinc * ingredient.nutritionMultiplier)
          return x
        })
        return x
      })
      let sum = x.reduce((a, b) =>{
        return a + b
      }, 0)
      return Math.round(sum/servings) }

      let fat
      let zinc 
      let potas 
      let iron 
      let calories
      let calc
      let vitD
      let vitC
      let vitB12
      let vitA
      let protein
      let sugar
      let fiber
      let carbs
      let sodium
      let cholest
      let satFat 

      if(props.data.contentfulBlogPost.subcategory[0].name === 'Recipes' && isRoundup === false) {
      
       fat = fatCalc(groups)
       zinc = zincCalc(groups)
       potas = potasCalc(groups)
       iron = ironCalc(groups)
       calories = caloriesCalc(groups)
       calc = calcCalc(groups)
       vitD = vitDCalc(groups)
       vitC = vitCCalc(groups)
       vitB12 = vitB12Calc(groups)
       vitA = vitACalc(groups)
       protein = proteinCalc(groups)
       sugar = sugarCalc(groups)
       fiber = fiberCalc(groups)
       carbs = carbsCalc(groups)
       sodium = sodiumCalc(groups)
       cholest = cholestCalc(groups)
       satFat = satFatCalc(groups)
      }

  useEffect(() => {
    const cleanUp = firestore
      .collection(`comments`)
      .onSnapshot(snapshot => {
        const posts = snapshot.docs
        .filter(doc => doc.data().blogId === blogId)
        .map(doc => {
          return { key: doc.id, id: doc.id, ...doc.data() }
        })

        setComments(posts)
      })
    return () => cleanUp()
  }, [blogId])
  
let roundupList = []
if(isRoundup) {

props.data.contentfulBlogPost.roundupRecipeGroups.map(group => {
  group.recipe.map(recipe => {
    roundupList.push(recipe)
    return roundupList
  })
  return roundupList
})

}
// The following is currently unusable, but if Gatsby-Image ever adds the ability
// to add a class to the inner img tag, this would allow me to remove pinning ability
// from images I don't want pinned.
// G-I updated on 3/5/2021, added functionality
  useEffect(()=> {
    const noPin = document.getElementsByClassName("no-pin")
    let i
    let l = noPin.length;
    for (i = 0; i < l; i++) {
      noPin[i].setAttribute("data-pin-nopin", "true");
    }
  })

  useEffect(() => {
    const blogBody = document.getElementById("blogBody")
    const bodyH2 = document.getElementsByClassName("bodyH2")
    const bodyH3 = document.getElementsByClassName("bodyH3")

    let firstAd = document.createElement("div")
    firstAd.setAttribute("id", "responsive-incontent-01")
    firstAd.setAttribute("class", "incontent-ad")

    let secondAd = document.createElement("div")
    secondAd.setAttribute("id", "responsive-incontent-02")
    secondAd.setAttribute("class", "incontent-ad")

    let thirdAd = document.createElement("div")
    thirdAd.setAttribute("id", "responsive-incontent-03")
    thirdAd.setAttribute("class", "incontent-ad")

    let fourthAd = document.createElement("div")
    fourthAd.setAttribute("id", "responsive-incontent-04")
    fourthAd.setAttribute("class", "incontent-ad")

    let fifthAd = document.createElement("div")
    fifthAd.setAttribute("id", "responsive-incontent-05")
    fifthAd.setAttribute("class", "incontent-ad")

    if(!!bodyH2[0]) {
      blogBody.insertBefore(firstAd, bodyH2[0])
    }
    if (!!bodyH2[1]) {
      blogBody.insertBefore(secondAd, bodyH2[1])
    }
    if (!!bodyH2[2]) {
      blogBody.insertBefore(thirdAd, bodyH2[2])
    }
    if (!!bodyH3[1]) {
      blogBody.insertBefore(fourthAd, bodyH3[1])
    }
    if (!!bodyH3[2]) {
      blogBody.insertBefore(fifthAd, bodyH3[2])
    }
  
  }, [])
  
    return (
      
      <Layout location ={props.location}>
        <Seo 
          title={props.data.contentfulBlogPost.blogTitle} 
          description={props.data.contentfulBlogPost.metaDescription} 
          image={props.data.contentfulBlogPost.thumbnailImage.file.url} 
          imageAlt={props.data.contentfulBlogPost.thumbnailImage.title}
          publishedDate={dayjs(props.data.contentfulBlogPost.publishedDate).format("YYYY-MM-DD")}
          type={metaType}
          author={props.data.contentfulBlogPost.author[0].authorName}
          path={`/${props.data.contentfulBlogPost.category[0].slug}/${props.data.contentfulBlogPost.slug}`}
          />
          
          <Helmet>
          
          <script crossorigin type="text/javascript" async defer data-pin-hover="true" data-pin-tall="true" data-pin-custom="true" src="
//assets.pinterest.com/js/pinit.js"></script>
          {props.data.contentfulBlogPost.subcategory[0].name === 'Recipes' ? 
            <script crossorigin type="application/ld+json" id="blog-schema">
              {`[
                ${isRoundup === false ? `
                {
                  "@context": "https://schema.org/",
                  "@type": "Recipe",
                  "name": ${JSON.stringify(props.data.contentfulBlogPost.blogTitle)},
                  "image": [
                    "https:${props.data.contentfulBlogPost.thumbnailImage.file.url}?fit=fill&w=1200&h=1200",
                    "https:${props.data.contentfulBlogPost.thumbnailImage.file.url}?fit=fill&w=1200&h=900",
                    "https:${props.data.contentfulBlogPost.thumbnailImage.file.url}?fit=fill&w=1600&h=900"
                  ],
                  "author": {
                    "@type": "Organization",
                    "name": "${props.data.contentfulBlogPost.author[0].authorName}"
                  },
                  ${!!aggregateRating === true ? 
                    `
                    "aggregateRating": {
                      "@type": "AggregateRating",
                      "ratingValue": "${aggregateRating}",
                      "ratingCount": "${ratingQuantity}"
                    },
                    `
                    : ``}
                  ${post.youtubeVideo ? 
                    `"video": [
                    {
                      "@type": "VideoObject",
                      "name": ${JSON.stringify(post.youtubeVideo.title).replace(/<[^>]+>/g, '')}, 
                      "embedUrl": "${post.youtubeVideo.embedUrl}",
                      "contentUrl": "${post.youtubeVideo.contentUrl}",
                      "description": ${JSON.stringify(post.youtubeVideo.description.description).replace(/<[^>]+>/g, '')},
                      "thumbnailUrl": "${post.youtubeVideo.thumbnail.imgixImage.url}",
                      "uploadDate": "${dayjs(post.youtubeVideo.uploadDate).format("YYYY-MM-DD")}"
                    }
                  ],` : `` }
                  "datePublished": "${dayjs(props.data.contentfulBlogPost.publishedDate).format("YYYY-MM-DD")}",
                  ${props.data.contentfulBlogPost.modifiedDate ? `
                  "dateModified": "${dayjs(props.data.contentfulBlogPost.modifiedDate).format("YYYY-MM-DD")}",
                  ` : ``}
                  "description": ${JSON.stringify(props.data.contentfulBlogPost.metaDescription.replace(/"/g, '\\"'))},
                  "prepTime": "${props.data.contentfulBlogPost.prepTime}",
                  "cookTime": "${props.data.contentfulBlogPost.cookTime}",
                  "totalTime": "${props.data.contentfulBlogPost.totalTime}",
                  "keywords": "${props.data.contentfulBlogPost.keywords.replace(/"/g, '\\"')}",
                  "recipeYield": "${props.data.contentfulBlogPost.servings}",
                  "recipeCategory": "${props.data.contentfulBlogPost.recipeCategory.replace(/"/g, '\\"')}",
                  "recipeCuisine": "${props.data.contentfulBlogPost.recipeCuisine.replace(/"/g, '\\"')}",
                  "suitableForDiet": "https://schema.org/VeganDiet",
                  "nutrition": {
                    "@type": "NutritionInformation",
                    "servingSize":"1/${props.data.contentfulBlogPost.servings} of recipe",
                    "calories":"${calories}",
                    "carbohydrateContent":"${carbs}",
                    "cholesterolContent":"${cholest}",
                    "fatContent":"${fat}",
                    "fiberContent":"${fiber}",
                    "proteinContent":"${protein}",
                    "saturatedFatContent":"${satFat}",
                    "sodiumContent":"${sodium}",
                    "sugarContent":"${sugar}"
                  },
                  "recipeIngredient": [${
                    props.data.contentfulBlogPost.recipeIngredientGroup.map((group) => {
                    let x = []
                    group.ingredients.map((ingredient) => {
                      x.push(`"${ingredient.ingredientSchemaName.replace(/"/g, '\\"')}"`)
                      return x
                    })
                    return x
                  })}],
                  
                  "recipeInstructions": [${props.data.contentfulBlogPost.recipeInstructions.map((instruction) => {
                    return ` 
                    {
                      "@type": "HowToStep",
                      "name": ${JSON.stringify(instruction.name)},
                      "text": ${JSON.stringify(instruction.text.childMarkdownRemark.html).replace(/<[^>]+>/g, '')}${instruction.image !== null ? `,
                      "image": "${instruction.image.imgixImage.url}"` : `` }
                    }`;
                    })},
                    
                    {
                      "@type": "HowToStep",
                      "itemListElement": [
                        ${props.data.contentfulBlogPost.recipeNotes.map((note) => {
                          return `
                            {
                              "@type": "HowToTip",
                              "text": ${JSON.stringify(note).replace(/<[^>]+>/g, '')}
                            }
                          `;
                        })}
                      ]
                    }
                  ]
                },
              ` : ``}
                ${isRoundup === true ?
                  `
                  {
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "itemListElement": [${roundupList.map((recipe, index) => {
                      return (
                      ` 
                      {
                          "@type": "ListItem",
                          "position": ${index + 1},
                          "url": ${recipe.recipe ? `"https://www.stephsunshine.com/${recipe.recipe.category[0].slug}/${recipe.recipe.slug}/"` : `"${recipe.url}"` }
                        }`
                      )
                    })}
                    ]
                  },
              `  : ``}
                {
                  "@context": "https://schema.org",
                  "@type": "BreadcrumbList",
                  "itemListElement": [
                    {
                      "@type": "ListItem",
                      "position": 1,
                      "name": "Vegan Life",
                      "item": "https://www.stephsunshine.com/vegan-life"
                    },{
                      "@type": "ListItem",
                      "position": 2,
                      "name": "Recipes",
                      "item": "https://www.stephsunshine.com/vegan-life/recipes"
                    }${isRoundup === false ? `,{
                      "@type": "ListItem",
                      "position": 3,
                      "name": "${props.data.contentfulBlogPost.meal[0].name}",
                      "item": "${`https://www.stephsunshine.com/vegan-life/recipes/${props.data.contentfulBlogPost.meal[0].slug}`}"
                    }` : ``}
                  ]
                }
              ]`}
              </script> : ``
            }
                  {props.data.contentfulBlogPost.subcategory[0].name !== 'Recipes' ? 
             <script type="application/ld+json" id="blog-2-schema">
             {`
             {
               "@context": "https://schema.org",
               "@type": "BlogPosting",
               "headline": ${JSON.stringify(props.data.contentfulBlogPost.blogTitle)},
               "image": [
                 "https:${props.data.contentfulBlogPost.thumbnailImage.file.url}?fit=fill&w=1200&h=1200",
                 "https:${props.data.contentfulBlogPost.thumbnailImage.file.url}?fit=fill&w=1200&h=900",
                 "${props.data.contentfulBlogPost.thumbnailImage.imgixImage.url}"
               ],
               ${post.youtubeVideo ? 
                `"video": [
                  {
                    "@type": "VideoObject",
                    "name": ${JSON.stringify(post.youtubeVideo.title).replace(/<[^>]+>/g, '')}, 
                    "embedUrl": "${post.youtubeVideo.embedUrl}",
                    "contentUrl": "${post.youtubeVideo.contentUrl}",
                    "description": ${JSON.stringify(post.youtubeVideo.description.description).replace(/<[^>]+>/g, '')},
                    "thumbnailUrl": "${post.youtubeVideo.thumbnail.imgixImage.url}",
                    "uploadDate": "${dayjs(post.youtubeVideo.uploadDate).format("YYYY-MM-DD")}"
                  }
                
              ],` : `` }
              ${props.data.contentfulBlogPost.modifiedDate ? `
                  "dateModified": "${dayjs(props.data.contentfulBlogPost.modifiedDate).format("YYYY-MM-DD")}",
                  ` : ``}
               "datePublished": "${dayjs(props.data.contentfulBlogPost.publishedDate).format("YYYY-MM-DD")}"
             }` } 
             </script> :
            ``
              }


              
              
          </Helmet>
        <div className={`ss-container ${blogPageStyles.main}`}>
          <div className={blogPageStyles.blogContainer}>
          {isRecipe ? 
          <div className={blogPageStyles.categories}>
            <Link className={blogPageStyles.breadcrumbLink} to ="/vegan-life">Vegan Life</Link> &gt; <Link className={blogPageStyles.breadcrumbLink} to="/vegan-life/recipes">Recipes</Link> {meal.length > 0 ? <span> &gt; <Link className={blogPageStyles.breadcrumbLink} to={`/vegan-life/recipes/${meal[0].slug}`}>{meal[0].name}</Link></span> : null } &gt; <span>{props.data.contentfulBlogPost.blogTitle}</span>
          </div> : 
          <p className={blogPageStyles.categories}>{props.data.contentfulBlogPost.category[0].name} | {props.data.contentfulBlogPost.subcategory[0].name}</p>}
            <h1 className={blogPageStyles.blogTitle}>{props.data.contentfulBlogPost.blogTitle} <span role="doc-subtitle">{props.data.contentfulBlogPost.subtitle}</span></h1>
            
            {!!props.data.contentfulBlogPost.modifiedDate === true ? 
            <div>
            <p className={blogPageStyles.blogDate}><b>Published: </b>{dayjs(props.data.contentfulBlogPost.publishedDate).format("MMMM D, YYYY")}
          </p>
            <p className={blogPageStyles.blogDate}><b>Modified: </b>{dayjs(props.data.contentfulBlogPost.modifiedDate).format("MMMM D, YYYY")}
            </p>
            </div>
          : 
              <p className={blogPageStyles.blogDate}>
            {dayjs(props.data.contentfulBlogPost.publishedDate).format("MMMM D, YYYY")}
          </p>}
            


          {props.data.contentfulBlogPost.containsAffiliateLinks !== false ? 
            <div className={blogPageStyles.affiliateDisclaimer}>Note: This post may contain affiliate links. As an Amazon associate, I earn from qualifying purchases. For more information, please read my <Link to="/terms" className={blogPageStyles.termsLink}>full disclosure.</Link></div>
          : <div></div> }
            { props.data.contentfulBlogPost.subcategory[0].name === 'Recipes' && isRoundup === false ? 
            <div>
              <div className={blogPageStyles.jumpContainer}>
                <div className={`btn-color ${blogPageStyles.btnOutline}`}>
                  <Link className={blogPageStyles.jumpButton} to="#recipe">Skip to Recipe</Link>
                </div>
              </div>
              { props.data.contentfulBlogPost.sellPara ?
                <div className={blogPageStyles.sellPara} id="sellPara">{renderRichText(props.data.contentfulBlogPost.sellPara, options)}</div>
                : <div></div> }
              <div className={blogPageStyles.heroImage}>
                <GatsbyImage
                  image={props.data.contentfulBlogPost.thumbnailImage.imgixImage.gatsbyImageData}
                  alt={props.data.contentfulBlogPost.thumbnailImage.title}
                  loading="eager" />
                  
              </div>
        
              </div> : 
              <div>
                
                <div>{ props.data.contentfulBlogPost.sellPara ?
                  <div>
                    <div className={blogPageStyles.sellPara} id="sellPara">{renderRichText(props.data.contentfulBlogPost.sellPara, options)}</div>
                  
                <div className={blogPageStyles.btnContainer}>
                <div className={`btn-color ${blogPageStyles.btnOutline}`}>
                  <OutboundLink 
                    className={blogPageStyles.jumpButton} 
                    target="_blank" 
                    rel="noreferrer noopener" 
                    href="https://www.pinterest.com/pin/create/button/" 
                    data-pin-do="buttonBookmark"
                    data-pin-media={props.data.contentfulBlogPost.pinterestImage.imgixImage.url}>
                    <Pinterest className={blogPageStyles.socialIcon} />Pin it
                  </OutboundLink>
                  
                </div>
                </div>
                </div>
              
              : <div></div> }</div> </div>}
            
            {props.data.contentfulBlogPost.showToc === true ? 
              <div className={blogPageStyles.toc}>
                <div className={blogPageStyles.tocInnerBox}>
                  <h2 className={blogPageStyles.tocHeading}>Contents</h2>
                  <ul className={blogPageStyles.tocContents}>
                    {documentToReactComponents(tocDocument, tocOptions)}
                  </ul>

                </div> 
              </div>
              
            : <div className='showFalse'></div>}
            {props.data.contentfulBlogPost.showTocH2Only === true ? 
              <div className={blogPageStyles.toc}>
                <div className={blogPageStyles.tocInnerBox}>
              <h2 className={blogPageStyles.tocHeading}>Contents</h2>
              <ul className={blogPageStyles.tocContents}>
                {documentToReactComponents(tocH2Document, tocOptions)}
                {isRoundup === false ? <Link to={`#recipe`}><li className={blogPageStyles.tocH2}>Recipe</li></Link>: <div></div>}
                <Link to={`#comments`}><li className={blogPageStyles.tocH2}>Comments & Ratings</li></Link>
              </ul>
              </div>
            </div> 
            : <div></div> }

{/* {isRecipe ? 
          <SaveRecipeForm blogTitle={props.data.contentfulBlogPost.blogTitle} path={blogPath} /> : 
          <div></div>} */}

            <div className={blogPageStyles.blogBody} id="blogBody">{renderRichText(props.data.contentfulBlogPost.body, options)}</div>

        

{/* Recipe Card here */}
{ props.data.contentfulBlogPost.subcategory[0].name === 'Recipes' && isRoundup === false ? 
            
            <Suspense fallback={<div>Loading...</div>}>
            <RecipeCard 
              recipe={props.data.contentfulBlogPost}
              rating={aggregateRating}
              ratingQty={ratingQuantity}
              calories={calories}
              fat={fat}
              satFat={satFat}
              cholest={cholest}
              sodium={sodium}
              carbs={carbs}
              fiber={fiber}
              sugar={sugar}
              protein={protein}
              vitA={vitA}
              vitB12={vitB12}
              vitC={vitC}
              vitD={vitD}
              calc={calc}
              iron={iron}
              potas={potas}
              zinc={zinc}
              />
              </Suspense>
            : 
            <div></div> }
          
          


              {/* Roundup Post here  */}

              {isRoundup === true ? 
              <div className={blogPageStyles.roundupGroups}>
                {props.data.contentfulBlogPost.roundupRecipeGroups.map(group => {
                  return(
                    <div key={group.title}>
                      {!!group.title ? <h2 className={blogPageStyles.h2} id={group.title}>{group.title}</h2> : ''}
                      {!!group.description ? <p className={blogPageStyles.p}>{group.description.description}</p>: ''}
                      <ul className={blogPageStyles.roundupGroups}>
                        {group.recipe.map(recipe => {
                          return (
                            <li key={recipe.recipe ? recipe.recipe.slug : recipe.url} className={`${blogPageStyles.blogBody} ${blogPageStyles.roundupLi}`}>
                              {recipe.recipe ? 
                              <Link to={`/${recipe.recipe.category[0].slug}/${recipe.recipe.slug}`}><h3 className={blogPageStyles.roundupHeadline}>{recipe.name}</h3>
                                    <div className={blogPageStyles.roundupRecipeSummary}>
                                      <div><span>Easy?</span> {recipe.recipe.easy ? `Yes` : `No`} </div>
                                      <div><span>Prep Time:</span> {humanizeDuration(dayjs.duration(recipe.recipe.prepTime))}</div> 
                                      <div><span>Cook Time:</span> {humanizeDuration(dayjs.duration(recipe.recipe.cookTime))}</div> 
                                      <div><span>Total Time:</span> {humanizeDuration(dayjs.duration(recipe.recipe.totalTime))}</div>
                                    </div>
                                    <GatsbyImage
                                      image={recipe.recipe.thumbnailImage.imgixImage.gatsbyImageData}
                                      className={blogPageStyles.roundupImage}
                                      alt={recipe.recipe.thumbnailImage.title} />
                                  </Link> : 
                                  <a href={recipe.url}><h3 className={blogPageStyles.roundupHeadline}>{recipe.name}</h3>
                                    <div className={blogPageStyles.roundupRecipeSummary}>
                                      <div><span>Easy?</span> {recipe.easy ? `Yes` : `No`} </div>
                                      <div><span>Prep Time:</span> {humanizeDuration(dayjs.duration(recipe.prepTime))}</div> 
                                      <div><span>Cook Time:</span> {humanizeDuration(dayjs.duration(recipe.cookTime))}</div> 
                                      <div><span>Total Time:</span> {humanizeDuration(dayjs.duration(recipe.totalTime))}</div>
                                    </div>
                                    <GatsbyImage
                                      image={recipe.image.imgixImage.gatsbyImageData}
                                      className={blogPageStyles.roundupImage}
                                      imgClassName="no-pin"
                                      alt={recipe.image.title} />
                                  </a>
                                  }
                                <p>{renderRichText(recipe.description)}</p>
                                <div className={blogPageStyles.btnBox}>
                                <div className={`btn-color ${blogPageStyles.btnOutline} ${blogPageStyles.btnCenter}`}>
                                 {recipe.recipe?
                                 <Link to={`/${recipe.recipe.category[0].slug}/${recipe.recipe.slug}`} className={blogPageStyles.jumpButton}>Get the Recipe</Link>
                                 :
                                 <a href={recipe.url} className={blogPageStyles.jumpButton}>Get the Recipe</a> } 
                                </div>
                                </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )
                } )}
              </div> : 
              <div></div>}


            <div className={blogPageStyles.blogSignature}>Steph<span>Sunshine</span></div>
            <Suspense fallback={<div>Loading...</div>}>
            <SocialShareFull shareURL={`https://www.stephsunshine.com/${props.data.contentfulBlogPost.category[0].slug}/${props.data.contentfulBlogPost.slug}`} 
              title={props.data.contentfulBlogPost.blogTitle}
              caption={props.data.contentfulBlogPost.metaDescription}
              isRecipe={isRecipe}
              image={props.data.contentfulBlogPost.thumbnailImage.imgixImage.url}
              pinterestImage={`${props.data.contentfulBlogPost.pinterestImage.imgixImage.url}`} />
              </Suspense>
            
            <div className={blogPageStyles.relatedPosts}>
              <h2 className={blogPageStyles.relatedPostsHeadline}>You might also like:</h2>
              <div className={blogPageStyles.relatedPostsBlock}>
                {props.data.contentfulBlogPost.relatedPosts.map((relatedPost) =>{
                  return (
                    <div className={blogPageStyles.relatedPost} key={relatedPost.slug}>
                      <Link to={`/${relatedPost.category[0].slug}/${relatedPost.slug}`}>
                        <GatsbyImage
                          image={relatedPost.thumbnailImage.imgixImage.gatsbyImageData}
                          className={blogPageStyles.relatedPostImage}
                          imgClassName="no-pin"
                          alt={relatedPost.thumbnailImage.title} />
                        <p className={blogPageStyles.relatedPostTitle}>{relatedPost.blogTitle}</p>
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
            {isRecipe ? 
            <div>
              <p className={blogPageStyles.tagsLabel}>Recipe Categories: </p>
              {meal.map((meal) => {
                if(meal.blog_post.length >= 5) {
                  return (
                <Link to={`/vegan-life/recipes/${meal.slug}`} key={meal.name} className={blogPageStyles.tagBlock}>{meal.name}</Link>
              )}
              return null
            })}

            {mealType.map((mealType) => {
                if(mealType.blog_post.length >= 5) {
                  return (
                <Link to={`/vegan-life/recipes/${mealType.slug}`} key={mealType.name} className={blogPageStyles.tagBlock}>{mealType.name}</Link>
              )}
              return null
                  })}

          {occasion.map((occasion) => {
                if(occasion.blog_post.length >= 5) {
                  return (
                <Link to={`/vegan-life/recipes/${occasion.slug}`} key={occasion.name} className={blogPageStyles.tagBlock}>{occasion.name}</Link>
              )}
              return null
                  })}
                  {mainIngredient.map((mainIngredient) => {
                if(mainIngredient.blog_post.length >= 5) {
                  return (
                <Link to={`/vegan-life/recipes/${mainIngredient.slug}`} key={mainIngredient.name} className={blogPageStyles.tagBlock}>{mainIngredient.name}</Link>
              )}
              return null
                  })}
                  

{cuisine.map((cuisine) => {
                if(cuisine.blog_post.length >= 5) {
                  return (
                <Link to={`/vegan-life/recipes/${cuisine.slug}`} key={cuisine.name} className={blogPageStyles.tagBlock}>{cuisine.name}</Link>
              )}
              return null
                  })}

{props.data.contentfulBlogPost.easy ?
                <Link to={`/vegan-life/recipes/easy`} key="easy" className={blogPageStyles.tagBlock}>Easy</Link>
              : null}
         
              {
              
              dayjs.duration(totalTime).$ms <= dayjs.duration(`PT30M`).$ms ?
                <Link to={`/vegan-life/recipes/30-minute`} key="30 Minute" className={blogPageStyles.tagBlock}>30 Minutes or Less</Link>
              : null}

{dayjs.duration(totalTime).$ms <= dayjs.duration(`PT45M`).$ms ?
                <Link to={`/vegan-life/recipes/45-minute`} key="45 Minute" className={blogPageStyles.tagBlock}>45 Minutes or Less</Link>
              : null}

{ingLength <= 10 ?
                <Link to={`/vegan-life/recipes/10-ingredient`} key="10 Ingredient" className={blogPageStyles.tagBlock}>10 Ingredients or Fewer</Link>
              : <div></div>}
            </div>: 
            <div className={blogPageStyles.tags}>
            <p className={blogPageStyles.tagsLabel}>Tags: </p>
            
            {props.data.contentfulBlogPost.tags.map((tag) => {
              return (
                <Link to={`/tag/${tag.slug}`} key={tag.name} className={blogPageStyles.tagBlock}>{tag.name}</Link>
              )
            })}
            
          </div>}
            
            <div>
            <Suspense fallback={<div>Loading...</div>}>
            <Comments comments={comments} blogId={blogId} path={blogPath} />
            </Suspense>
          
      </div>
          </div>
          <div className={blogPageStyles.sidebar}>
            { props.data.contentfulBlogPost.youtubeLink !== null ? 
                            <div className={blogPageStyles.videoBlock}>
                              <p className={blogPageStyles.videoText}>Watch this as a video instead:</p>
                              <Suspense fallback={<div>Loading...</div>}>
                              <VideoFrame width="308" height="173" title={props.data.contentfulBlogPost.blogTitle} className={blogPageStyles.video} src={`${props.data.contentfulBlogPost.youtubeLink}`} ></VideoFrame>
                             </Suspense>
                            </div> : null
              
            }
            {props.data.contentfulBlogPost.author.map((author) => {
              return (
                <div className={blogPageStyles.authorBlock} key={author.authorName}>
                  <Link to ="/about">
                    <GatsbyImage
                      image={author.authorProfilePicture.imgixImage.gatsbyImageData}
                      className={blogPageStyles.authorPic}
                      imgClassName={`no-pin ${blogPageStyles.authorImg}`}
                      loading="eager"
                      alt={author.authorProfilePicture.description} />
                  </Link>
                  <div className={blogPageStyles.authorTextBlock}>
                    <Link to ="/about">
                      <h2 className={blogPageStyles.authorName}>{author.authorName}</h2>
                    </Link>
                    <div className={blogPageStyles.authorBio}>{renderRichText(author.authorBio)}</div>
                  </div>
                </div>
              );
            })}


            <div className={blogPageStyles.socialBlock}>
            <Suspense fallback={<div>Loading...</div>}>
              <SocialBlock />
              </Suspense>
              </div>
              
              <div>
              {props.data.allContentfulSidebarRecipes.edges.map((edge) => {
                
                if(edge.node.display === true) {
                  return (
                  <div className={blogPageStyles.suggestRecipes} key={edge.node.contentful_id}>
                    <h2 className={blogPageStyles.suggestRecipesHeading}>{edge.node.groupName}</h2>
                    <div className={blogPageStyles.suggestRecipesBlock}>
                      {edge.node.recipe.map((recipe) => {
                        return (
                        <div className={blogPageStyles.suggestRecipesRecipe} key={recipe.slug}>
                          <Link to={`/${recipe.category[0].slug}/${recipe.slug}`}>
                            <GatsbyImage 
                              image={recipe.thumbnailImage.imgixImage.gatsbyImageData}
                              className={blogPageStyles.suggestRecipesRecipeImage}
                              alt={recipe.thumbnailImage.title}
                              imgClassName="no-pin" />
                            <h3 className={blogPageStyles.suggestRecipesRecipeTitle}>{recipe.blogTitle}</h3>
                          </Link>
                          
                        </div>)
                      })}
                    </div>
                  </div> )
                }  return null
              })}
              </div>
              
          </div>
        </div>
        
      </Layout>
    );
}

export default Blog